import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-619be318"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "question-detail",
  id: "questionAllData",
  "talqs-app": ""
}
const _hoisted_2 = {
  key: 0,
  class: "m-dot-que-section"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label" }, "请作答：", -1))
const _hoisted_4 = { class: "only-options-section" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "answer-value" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.displayRange === $setup.displayRangeMap.QUE_OPTIONS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.answerOptionList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `answer-${item?.[0]?.aoVal}`,
                class: _normalizeClass(["answer-option-tile only-options", { 'u-choosed': $setup.curClickVal === item?.[0]?.aoVal, 'u-error': $setup.curClickVal === item?.[0]?.aoVal && !$setup.rightAnswer.includes(item?.[0]?.aoVal), 'u-right': $setup.curClickVal && $setup.rightAnswer.includes(item?.[0]?.aoVal)}]),
                onClick: ($event: any) => ($setup.handleOptionsClick(item?.[0]?.aoVal))
              }, _toDisplayString(item?.[0]?.aoVal), 11, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    ($props.displayRange === $setup.displayRangeMap.QUE_ALL)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "m-dot-que-section",
          style: _normalizeStyle($setup.queSectionStyle),
          ref: "refQueDetail"
        }, [
          _createElementVNode("div", {
            class: "m-section-content question-title question-title-tool",
            ref: "refQueTileWrapFake",
            id: `questionTitle_${$props.questionData.queId}_${$props.questionIndex}_01`
          }, null, 8, _hoisted_6),
          _createElementVNode("div", {
            class: "m-section-content question-title",
            ref: "refQueTileWrap",
            id: `questionTitle_${$props.questionData.queId}_${$props.questionIndex}`
          }, null, 8, _hoisted_7),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.answerOptionList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `answer-${item?.[0]?.aoVal}`,
                class: _normalizeClass(["answer-option-tile", {'u-choosed': $setup.curClickVal === item?.[0]?.aoVal, 'u-error': $setup.curClickVal === item?.[0]?.aoVal && !$setup.rightAnswer.includes(item?.[0]?.aoVal), 'u-right': $setup.curClickVal && $setup.rightAnswer.includes(item?.[0]?.aoVal)}]),
                onClick: ($event: any) => ($setup.handleOptionsClick(item?.[0]?.aoVal))
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(item?.[0]?.aoVal) + ".", 1),
                _createElementVNode("div", {
                  class: "answer-desc",
                  innerHTML: item?.[0]?.content
                }, null, 8, _hoisted_10)
              ], 10, _hoisted_8))
            }), 128))
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}